import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: localStorage.getItem("token") || null,
  account: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { token, account } = action.payload;
      state.token = token;
      state.account = account;
      localStorage.setItem("token", token);
    },
    logout: (state) => {
      state.token = null;
      state.account = null;
      localStorage.removeItem("token");
    },
    setAccount: (state, action) => {
      state.account = action.payload;
    },
  },
});

export const { setCredentials, logout,setAccount } = authSlice.actions;
export default authSlice.reducer;
